export const deleteKeys = <T extends Record<string, unknown>, K extends (keyof T)[]>(
  keys: K,
  object: T,
): Omit<T, K[number]> => {
  const objectCopy = { ...object }

  for (const key of keys) {
    if (key in objectCopy) {
      delete objectCopy[key]
    }
  }

  return objectCopy
}
